<div class="m-3 px-4 container row justify-content-center">
    <div class="col-6 text-center">
        <div class="photo">
            <img src="../../../assets/img/doctorperfile.jpg" class="rounded-circle" alt="" width="300px">            
        </div>
    </div>
    <div class="col-6">
        <h1>Gabo Ruiz</h1>
        <h4><strong>Nombre:</strong> gabo@ruiz.com</h4>
        <h4><strong>Especialidad:</strong> Psicologo</h4>
        <h4><strong>Teléfono:</strong> +58 1234123</h4>
        <h4><strong>Verificación:</strong> Pendiente</h4>
        <button class="btn btn-primary uppercase">Compartir</button>
    </div>
</div>
